// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"e7934bcd","92":"b4766b0b","119":"51c5cd0e","146":"c0fb0c2e","518":"e40bb9e9","878":"383e99e6"}[chunkId] + ".chunk.js";
};